export default {
  call: 'Позвонить',
  text: 'Сообщение',
}
